import Carousel from "bootstrap.native/src/components/carousel-native";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.carousel = new Carousel(this.element);
  }

  disconnect() {
    this.carousel.dispose();
  }
}
